// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CautionIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from caution.svg
 */
export default function CautionIcon(props: CautionIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CautionIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8 0c.767 0 1.432.455 1.794 1.148l5.917 11.326c.386.738.36 1.573.071 2.23-.286.651-.926 1.296-1.864 1.296H2.082c-.938 0-1.578-.645-1.864-1.295a2.6 2.6 0 0 1 .07-2.23L6.207 1.147C6.568.455 7.233 0 8 0m0 2.038-.021.036L2.06 13.4a.6.6 0 0 0-.012.5.3.3 0 0 0 .062.1H13.89a.3.3 0 0 0 .061-.1.6.6 0 0 0-.012-.5L8.02 2.074zm5.874 11.972q0 0 .01-.006-.01.007-.01.006m-11.748 0q0 .002-.01-.006z"
        />
        <path
          fill="currentColor"
          d="M8 5a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1M9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        />
      </g>
    </svg>
  );
}
